import API from "store/api"
import { SET_CURRENT_ORG } from "types/actions/organization"
import { setMembers } from "./members"
import { logout } from "./authentication"

export const setOrg = data => {
  return {
    type: SET_CURRENT_ORG,
    data
  }
}

export const getCurrentOrg = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.get(`/users/check/${id}`)
        .then(response => {
          // console.log({ response })
          if (response.statusCode === 200 && response.body.data !== null) {
            dispatch(setOrg(response.body.data))
            resolve(response)
          } else {
            // console.log(response)
            if (
              window.location.pathname !== "/noorganizationpage" &&
              window.location.pathname !== "/app/add-org" &&
              window.location.pathname !== "/login"
            ) {
              dispatch(logout())
            }
            resolve(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
    return deferred
  }
}

export const getLogo = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.post(`/orgs/logo`)
        .send(data)
        .then(response => {
          resolve(response.body.data[0])
        })
        .catch(error => {
          reject(error)
        })
    })
    return deferred
  }
}

export const getManifest = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.get(`/orgs/manifest`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
        })
    })
    return deferred
  }
}

export const updateOrganization = (data, id) => {
  data = Object.assign({}, data)
  if (data.logo && data.logo.indexOf("organization") !== -1) {
    delete data.logo
  }
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.post(`/orgs/settings/${id}`)
        .send(data)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const createAdditionalField = (data, id) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.post(`/orgs/field/${id}`)
        .send(data)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const updateAdditionalField = (data, id) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.put(`/orgs/field/${id}`)
        .send(data)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const deleteAdditionalField = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.delete(`/orgs/fields/${id}`)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const disconnectPartner = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.delete(`/orgs/connect/${id}`)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const connectPartner = ids => {
  // console.log(ids)
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.post(`/orgs/connect/`)
        .send({ partnerIds: ids })
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          }
        })
    })
    return deferred
  }
}

export const setCanPost = (id, canPost) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.put(`/orgs/canpost/${id}`)
        .send({ can_post: canPost ? 1 : 0 })
        .then(response => {
          if (response.statusCode === 200) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
    return deferred
  }
}

export const setNeedsApproval = (id, needsApproval) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.post(`/orgs/settings/${id}`)
        .send({ needs_approval: needsApproval ? 1 : 0 })
        .then(response => {
          if (response.statusCode === 200) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
    return deferred
  }
}

export const acceptPartnerRequest = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.put(`/orgs/connect/${id}`)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          }
        })
        .catch(err => reject(err))
    })
    return deferred
  }
}

export const getMembers = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.get(`/orgs/members`)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(setMembers(response.body.users))
            resolve(response.body)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const updateRole = (id, role) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.put(`/orgs/role/${id}`)
        .send({ role_id: role })
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getMembers())
              .then(() => resolve(response))
              .catch(() => resolve(response))
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const removeOrgAccess = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.delete(`/orgs/user/${id}`)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getMembers())
              .then(() => resolve(response))
              .catch(() => resolve(response))
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const addUser = id => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/orgs/user/${id}`)
      .then(response => {
        if (response.statusCode === 200) {
          dispatch(getMembers())
            .then(() => resolve(response))
            .catch(() => resolve(response))
        } else {
          reject(response)
        }
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const socialConnect = id => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/social/twitter-auth/${id}`)
      .then(response => {
        window.location = response.body.redirect
        resolve(response)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const getOrgFields = id => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.get(`/orgs/field/${id}`)
      .then(response => {
        resolve(response)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const createOrg = data => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/orgs/`)
      .send(data)
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const checkOrgSubdomain = subdomain => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/orgs/subdomainCheck`)
      .send({ subdomain })
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const addStripeToOrg = (orgId, token) => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/orgs/addStripeToOrg/${orgId}`)
      .send({ token })
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const chargeOrgForSubscription = (orgId, coupon) => dispatch => {
  let query = coupon ? `?coupon=${coupon}` : ""
  const deferred = new Promise((resolve, reject) => {
    API.get(`/orgs/chargeOrgForSubscription/${orgId}${query}`)
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const checkCoupon = coupon => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/orgs/checkCoupon`)
      .send({ coupon })
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const createGroupCode = data => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/groupCodes/create`)
      .send({
        org_id: data.org_id,
        code: data.code,
        allowed_accounts: data.allowedAccounts
      })
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const removeNetwork = network => dispatch => {
  return new Promise((resolve, reject) => {
    const socialNetwork = network.toLowerCase()
    API.delete(`/orgs/network/${socialNetwork}`)
      .then(response => {
        if (response.statusCode === 200) {
          dispatch(getCurrentOrg())
            .then(resolve)
            .catch(reject)
        } else {
          reject(response)
        }
      })
      .catch(error => reject(error))
  })
}

export const checkGroupCode = code => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/groupCodes/check`)
      .send({ code })
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const deleteOrg = id => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.get(`/orgs/delete/${id}`)
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const checkSocialTokens = () => dispatch => {
  return new Promise((resolve, reject) => {
    API.get("/social/verify")
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
}

export const sendText = (id, ids, message) => dispatch => {
  return new Promise((resolve, reject) => {
    API.post(`/communication/text/${id}`)
      .send({ ids, message })
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
}

export const getEmailTags = id => dispatch => {
  return new Promise((resolve, reject) => {
    API.get(`/communication/tags/${id}`)
      .then(response => {
        dispatch(setOrg({ tags: response.body.data }))
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
}

export const addEmailTag = (id, name) => dispatch => {
  return new Promise((resolve, reject) => {
    API.post(`/communication/tag/${id}`)
      .send({ name })
      .then(response => {
        dispatch(getEmailTags(id)).then(response => {
          resolve(response.body)
        })
      })
      .catch(error => reject(error))
  })
}

export const deleteEmailTag = (id, tagId) => dispatch => {
  return new Promise((resolve, reject) => {
    API.delete(`/communication/tag/${id}`)
      .send({ tagId })
      .then(response => {
        dispatch(getEmailTags(id)).then(response => {
          resolve(response.body)
        })
      })
      .catch(error => reject(error))
  })
}

export const getEmails = id => dispatch => {
  return new Promise((resolve, reject) => {
    API.get(`/communication/emails/${id}`)
      .then(response => {
        dispatch(setOrg({ emails: response.body.data }))
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
}

export const addEmail = (id, email) => dispatch => {
  return new Promise((resolve, reject) => {
    API.post(`/communication/email/${id}`)
      .send({ email })
      .then(response => {
        const emailId = response.body.data.emailId
        dispatch(getEmails(id)).then(response => {
          resolve({ ...response, data: { ...response.data, emailId: emailId } })
        })
      })
      .catch(error => reject(error))
  })
}

export const removeEmail = (id, emailId) => dispatch => {
  return new Promise((resolve, reject) => {
    API.delete(`/communication/email/${id}`)
      .send({ emailId })
      .then(response => {
        dispatch(getEmails(id)).then(response => {
          resolve(response)
        })
      })
      .catch(error => reject(error))
  })
}

export const addEmailGroup = (id, emailId, tagIds) => dispatch => {
  return new Promise((resolve, reject) => {
    API.post(`/communication/group/${id}`)
      .send({ emailId, tagIds })
      .then(response => {
        resolve(response)
        // dispatch(getEmails(id)).then(response => {
        //   console.log(response)
        //   resolve({ ...response, data: { ...response.data, emailId: emailId } })
        // })
      })
      .catch(error => reject(error))
  })
}

export const removeEmailGroup = (id, emailId, tagId) => dispatch => {
  return new Promise((resolve, reject) => {
    API.delete(`/communication/group/${id}`)
      .send({ emailId, tagId })
      .then(response => {
        resolve(response)
        // dispatch(getEmails(id)).then(response => {
        //   console.log(response)
        //   resolve({ ...response, data: { ...response.data, emailId: emailId } })
        // })
      })
      .catch(error => reject(error))
  })
}

export const getEmailsWithTags = id => dispatch => {
  return new Promise((resolve, reject) => {
    API.get(`/communication/emails-tags/${id}`)
      .then(response => {
        dispatch(setOrg(response.body.data))
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
}

export const updateNotifications = (data, orgId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.put(`/orgs/post-notification/${orgId}`)
        .send(data)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}

export const updateWhiteLabeled = (data, orgId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.put(`/orgs/white-labeled/${orgId}`)
        .send(data)
        .then(response => {
          if (response.statusCode === 200) {
            dispatch(getCurrentOrg())
              .then(resolve)
              .catch(reject)
          } else {
            reject(response)
          }
        })
        .catch(error => reject(error))
    })
    return deferred
  }
}



// WEBPACK FOOTER //
// ./src/actions/organization.js